import React from 'react';
import MessageBlock from 'components/layout/MessageBlock';
import Toast from './Toast';

export const MessageToast = ({ toast, onClose }) => {
    if (!toast.show) return null;

    return (
        <Toast
            message={toast.message}
            type={toast.type}
            onClose={onClose}
        />
    );
};

export const MessageLoading = ({ message }) => (
    <MessageBlock
        message={message}
        iconClass="fa-arrows-spin fa-spin text-blue-mid"
        messageClass="text-gray-strong"
    />
);

export const MessageError = ({ message, error }) => (
    <MessageBlock
        message={`${message}: ${error?.message ?? 'Unknown error'}`}
        iconClass="fa-heart-crack text-red-mid"
        messageClass="text-red-strong"
    />
);

export const MessageEmpty = ({ message }) => (
    <MessageBlock
        message={message}
        iconClass="fa-thumbtack text-gray-mid"
        messageClass="text-gray-strong"
        blockClass="!h-auto !justify-top"
    />
);
